import { useQuery } from '@tanstack/react-query';
import { axiosInstance } from '../../utils';

interface Payload {
  id: string;
}

export const deleteCustomBrolls = async (payload: Payload): Promise<any> => {
  const { id } = payload;

  try {
    const res = await axiosInstance.delete(`/api/broll/delete-custom-broll/${id}`);
    return res.data;
  } catch (error) {
    console.log(error);
  }
};
